import { message } from 'antd';
import Axios from 'axios';
import { getCookie } from '../../common/common';

export const MINERAL_SAMPLE_LOADING = 'MINERAL_SAMPLE_LOADING';
export const mineralSampleLoading = (bool) => ({
    type: MINERAL_SAMPLE_LOADING,
    payload: bool
});

export const MINERAL_SAMPLE_SUCCESS = 'MINERAL_SAMPLE_SUCCESS';
export const mineralSampleSuccess = (bool) => ({
    type: MINERAL_SAMPLE_SUCCESS,
    payload: bool
});

export const GET_MINERAL_ANALYSIS_PRICES = 'GET_MINERAL_ANALYSIS_PRICES';
export const getMineralAnalysisPricesSuccess = (data) => ({
    type: GET_MINERAL_ANALYSIS_PRICES,
    payload: data
});

export function getMineralAnalysisPrices() {
    return dispatch => {
        let token = getCookie("authToken");
        
        Axios({
            method: 'get',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralAnalysisPrice/`,
            headers: {
                'Authorization': `JWT ${token}`
            }
        }).then((res) => {
            dispatch(getMineralAnalysisPricesSuccess(res.data.data || res.data));
        }).catch((err) => {
            console.error("Failed to fetch mineral analysis prices");
        });
    };
}

export function initializeMineralAnalysisPrices() {
    return dispatch => {
        let token = getCookie("authToken");
        
        Axios({
            method: 'post',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralAnalysisPrice/initialize`,
            headers: {
                'Authorization': `JWT ${token}`
            }
        }).then((res) => {
            dispatch(getMineralAnalysisPrices());
            message.success("Mineral analysis prices initialized");
        }).catch((err) => {
            console.error("Failed to initialize mineral analysis prices");
        });
    };
}

// ==================== MINERAL REPORT ACTIONS ====================

export const MINERAL_REPORT_LOADING = 'MINERAL_REPORT_LOADING';
export const mineralReportLoading = (bool) => ({
    type: MINERAL_REPORT_LOADING,
    payload: bool
});

export const MINERAL_REPORT_SUCCESS = 'MINERAL_REPORT_SUCCESS';
export const mineralReportSuccess = (bool) => ({
    type: MINERAL_REPORT_SUCCESS,
    payload: bool
});

export const CREATE_MINERAL_REPORT = 'CREATE_MINERAL_REPORT';
export const createMineralReportSuccess = (data) => ({
    type: CREATE_MINERAL_REPORT,
    payload: data
});

export const GET_MINERAL_REPORTS = 'GET_MINERAL_REPORTS';
export const getMineralReportsSuccess = (data) => ({
    type: GET_MINERAL_REPORTS,
    payload: data
});

export const GET_SINGLE_MINERAL_REPORT = 'GET_SINGLE_MINERAL_REPORT';
export const getSingleMineralReportSuccess = (data) => ({
    type: GET_SINGLE_MINERAL_REPORT,
    payload: data
});

export const UPDATE_MINERAL_REPORT = 'UPDATE_MINERAL_REPORT';
export const updateMineralReportSuccess = (data) => ({
    type: UPDATE_MINERAL_REPORT,
    payload: data
});

export const DELETE_MINERAL_REPORT = 'DELETE_MINERAL_REPORT';
export const deleteMineralReportSuccess = (reportNo) => ({
    type: DELETE_MINERAL_REPORT,
    payload: reportNo
});

export function createMineralReport(obj, callback) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");
        
        Axios({
            method: 'post',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralReport/`,
            headers: {
                'Authorization': `JWT ${token}`
            },
            data: obj
        }).then((res) => {
            dispatch(createMineralReportSuccess(res.data.data));
            dispatch(mineralReportSuccess(true));
            message.success("Mineral report created successfully");
            dispatch(mineralReportLoading(false));
            if (callback) callback(res.data.data);
        }).catch((err) => {
            dispatch(mineralReportLoading(false));
            dispatch(mineralReportSuccess(false));
            message.error("Failed to create mineral report");
        });
    };
}

export function getMineralReports(filters = {}, branchCode) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");
        
        let queryParams = `?page=${filters.page || 1}&page_size=${filters.page_size || 10}`;
        if (filters.status) queryParams += `&status=${filters.status}`;
        if (filters.searchText) queryParams += `&searchText=${filters.searchText}`;
        if (branchCode) queryParams += `&branchCode=${branchCode}`;
        
        Axios({
            method: 'get',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralReport/${queryParams}`,
            headers: {
                'Authorization': `JWT ${token}`
            }
        }).then((res) => {
            dispatch(getMineralReportsSuccess(res.data));
            dispatch(mineralReportLoading(false));
        }).catch((err) => {
            dispatch(mineralReportLoading(false));
            message.error("Failed to fetch mineral reports");
        });
    };
}

export function getSingleMineralReport(reportNo) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");
        
        Axios({
            method: 'get',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralReport/${reportNo}`,
            headers: {
                'Authorization': `JWT ${token}`
            }
        }).then((res) => {
            dispatch(getSingleMineralReportSuccess(res.data.data));
            dispatch(mineralReportLoading(false));
        }).catch((err) => {
            dispatch(mineralReportLoading(false));
            message.error("Failed to fetch mineral report");
        });
    };
}

export function getMineralReportByEntryNo(entryNo) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");
        
        Axios({
            method: 'get',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralReport/entry/${entryNo}`,
            headers: {
                'Authorization': `JWT ${token}`
            }
        }).then((res) => {
            dispatch(getSingleMineralReportSuccess(res.data.data));
            dispatch(mineralReportLoading(false));
        }).catch((err) => {
            dispatch(mineralReportLoading(false));
        });
    };
}

export function updateMineralReport(reportNo, obj, callback) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");
        
        Axios({
            method: 'put',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralReport/${reportNo}`,
            headers: {
                'Authorization': `JWT ${token}`
            },
            data: obj
        }).then((res) => {
            dispatch(updateMineralReportSuccess(res.data.data));
            dispatch(mineralReportLoading(false));
            message.success("Mineral report updated successfully");
            if (callback) callback(res.data.data);
        }).catch((err) => {
            dispatch(mineralReportLoading(false));
            message.error("Failed to update mineral report");
        });
    };
}

export function deleteMineralReport(reportNo, callback) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");
        
        Axios({
            method: 'delete',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralReport/${reportNo}`,
            headers: {
                'Authorization': `JWT ${token}`
            }
        }).then((res) => {
            dispatch(deleteMineralReportSuccess(reportNo));
            dispatch(mineralReportLoading(false));
            message.success("Mineral report deleted successfully");
            if (callback) callback();
        }).catch((err) => {
            dispatch(mineralReportLoading(false));
            message.error("Failed to delete mineral report");
        });
    };
}

// ==================== MINERAL SAMPLE LIST & UPDATE ====================

export const GET_MINERAL_SAMPLES = 'GET_MINERAL_SAMPLES';
export const getMineralSamplesSuccess = (data) => ({
    type: GET_MINERAL_SAMPLES,
    payload: data
});

export function getMineralSamples(filters = {}, branchCode) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");

        let queryParams = `?page=${filters.page || 1}&page_size=${filters.page_size || 10}`;
        if (filters.startDate) queryParams += `&startDate=${filters.startDate}`;
        if (filters.endDate) queryParams += `&endDate=${filters.endDate}`;
        if (branchCode) queryParams += `&branchCode=${branchCode}`;
        if (filters.searchText) queryParams += `&searchText=${filters.searchText}`;

        Axios({
            method: 'get',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralSample${queryParams}`,
            headers: { 'Authorization': `JWT ${token}` }
        }).then((res) => {
            dispatch(getMineralSamplesSuccess(res.data));
            dispatch(mineralReportLoading(false));
        }).catch(() => {
            dispatch(mineralReportLoading(false));
            message.error("Failed to fetch mineral samples");
        });
    };
}

export function updateMineralSampleEntry(entryNo, data, callback) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");

        Axios({
            method: 'put',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralSample/${entryNo}`,
            headers: { 'Authorization': `JWT ${token}` },
            data
        }).then((res) => {
            dispatch(mineralReportLoading(false));
            message.success("Mineral sample updated successfully");
            if (callback) callback();
        }).catch(() => {
            dispatch(mineralReportLoading(false));
            message.error("Failed to update mineral sample");
        });
    };
}

export function deleteMineralSampleEntry(entryNo, callback) {
    return dispatch => {
        dispatch(mineralReportLoading(true));
        let token = getCookie("authToken");

        Axios({
            method: 'delete',
            url: `${process.env.REACT_APP_NEW_BACKEND_URL}mineralSample/${entryNo}`,
            headers: { 'Authorization': `JWT ${token}` }
        }).then(() => {
            dispatch(mineralReportLoading(false));
            message.success("Mineral sample deleted successfully");
            if (callback) callback();
        }).catch(() => {
            dispatch(mineralReportLoading(false));
            message.error("Failed to delete mineral sample");
        });
    };
}